'use strict';

module.exports = {
  baseline: 'baseline',
  comparison: 'comparison',
  comparison2: 'comparison2',
};
